export const flavorsData = [
  {
    name: 'バニラビーン',
    price: '450',
    bgColor: '#FFF8E7',
    image: 'https://readdy.ai/api/search-image?query=Delicious%20vanilla%20bean%20ice%20cream%20cone%20with%20visible%20vanilla%20bean%20specks%2C%20handmade%20artisan%20style%2C%20creamy%20white%20color%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20cream%20color%2C%201950s%20American%20ice%20cream%20parlor%20aesthetic%2C%20appetizing%20presentation&width=400&height=400&seq=flavor-vanilla-001&orientation=squarish',
    description: 'マダガスカル産バニラビーンズをたっぷり使用。濃厚でクリーミーな味わいが特徴です。'
  },
  {
    name: 'ストロベリー',
    price: '480',
    bgColor: '#FFE5E5',
    image: 'https://readdy.ai/api/search-image?query=Fresh%20strawberry%20ice%20cream%20cone%20with%20real%20strawberry%20pieces%2C%20vibrant%20pink%20color%2C%20handmade%20artisan%20quality%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20pink%20color%2C%201950s%20American%20parlor%20style%2C%20delicious%20and%20inviting&width=400&height=400&seq=flavor-strawberry-001&orientation=squarish',
    description: '新鮮な苺をふんだんに使用。フルーティーで爽やかな甘さが口いっぱいに広がります。'
  },
  {
    name: 'ピスタチオ',
    price: '520',
    bgColor: '#E8F5E9',
    image: 'https://readdy.ai/api/search-image?query=Rich%20pistachio%20ice%20cream%20cone%20with%20natural%20green%20color%2C%20crushed%20pistachio%20nuts%20visible%2C%20handmade%20artisan%20style%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20mint%20green%2C%201950s%20American%20ice%20cream%20parlor%20aesthetic%2C%20premium%20quality&width=400&height=400&seq=flavor-pistachio-001&orientation=squarish',
    description: 'シチリア産ピスタチオを贅沢に使用。ナッツの香ばしさと上品な甘みが絶妙です。'
  },
  {
    name: 'チョコレート',
    price: '480',
    bgColor: '#F3E5D8',
    image: 'https://readdy.ai/api/search-image?query=Decadent%20dark%20chocolate%20ice%20cream%20cone%2C%20rich%20brown%20color%2C%20handmade%20artisan%20quality%20with%20smooth%20texture%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20beige%2C%201950s%20American%20parlor%20aesthetic%2C%20indulgent%20and%20appetizing&width=400&height=400&seq=flavor-chocolate-001&orientation=squarish',
    description: 'ベルギー産チョコレートを使用した濃厚な味わい。ビターな大人の味です。'
  },
  {
    name: 'ほうじ茶',
    price: '500',
    bgColor: '#FFF3E0',
    image: 'https://readdy.ai/api/search-image?query=Japanese%20hojicha%20roasted%20green%20tea%20ice%20cream%20cone%2C%20light%20brown%20color%2C%20handmade%20artisan%20style%20with%20subtle%20tea%20flavor%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20cream%2C%201950s%20American%20parlor%20meets%20Japanese%20aesthetic%2C%20elegant%20presentation&width=400&height=400&seq=flavor-hojicha-001&orientation=squarish',
    description: '京都産ほうじ茶を使用。香ばしい香りと優しい甘さが特徴の和風フレーバーです。'
  },
  {
    name: 'ソルティキャラメル',
    price: '500',
    bgColor: '#FFF9E6',
    image: 'https://readdy.ai/api/search-image?query=Salted%20caramel%20ice%20cream%20cone%20with%20caramel%20swirls%2C%20golden%20amber%20color%2C%20handmade%20artisan%20quality%2C%20served%20in%20golden%20waffle%20cone%2C%20simple%20clean%20background%20in%20soft%20yellow%2C%201950s%20American%20ice%20cream%20parlor%20style%2C%20sweet%20and%20salty%20perfection&width=400&height=400&seq=flavor-caramel-001&orientation=squarish',
    description: '自家製キャラメルに海塩をプラス。甘さと塩気の絶妙なバランスが癖になります。'
  }
];
